const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    width: "2.469444mm",
    height: "2.6493599mm",
    viewBox: "0 0 2.469444 2.6493599",
    id: "svg6273",
    "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
    "sodipodi:docname": "back_arrow_icon.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs6267"
  }), /*#__PURE__*/React.createElement("sodipodi:namedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    "inkscape:pageopacity": 0,
    "inkscape:pageshadow": 2,
    "inkscape:zoom": 0.35,
    "inkscape:cx": 4.666666,
    "inkscape:cy": 5.006652,
    "inkscape:document-units": "mm",
    "inkscape:current-layer": "layer1",
    showgrid: "false",
    "inkscape:window-width": 2880,
    "inkscape:window-height": 1674,
    "inkscape:window-x": 0,
    "inkscape:window-y": 60,
    "inkscape:window-maximized": 1
  }), /*#__PURE__*/React.createElement("metadata", {
    id: "metadata6270"
  }, /*#__PURE__*/React.createElement("rdf:RDF", null, /*#__PURE__*/React.createElement("cc:Work", {
    "rdf:about": ""
  }, /*#__PURE__*/React.createElement("dc:format", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dc:type", {
    "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dc:title", null)))), /*#__PURE__*/React.createElement("g", {
    "inkscape:label": "Layer 1",
    "inkscape:groupmode": "layer",
    id: "layer1",
    transform: "translate(82.499603,-147.50865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -80.030159,148.30593 h -0.705555 v -0.79728 l -1.763889,1.35114 1.763889,1.29822 v -0.79375 h 0.705555 v -1.05833",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    id: "path718",
    "inkscape:connector-curvature": 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/back_arrow_icon.3f4081e1855fe3c375c4e7de9253a48c.svg";
export { ForwardRef as ReactComponent };